import Layout from "../components/Layout";
import {createBrowserRouter, Navigate} from "react-router";
import Home from "../components/Home";
import PATH from "./routes";
import Contact from "../components/Contact";
import CampsEnglish from "../components/CampsEnglish";
import CampsClassics from "../components/CampsClassics";
import Registrations from "../components/Registrations";

const router = createBrowserRouter([
    {
        element: <Layout/>,
        children: [
            {path: PATH.HOME, element: <Home/>},
            {path: PATH.CAMPS_CLASSICS, element: <CampsClassics/>},
            {path: PATH.CAMPS_ENGLISH, element: <CampsEnglish/>},
            {path: PATH.REGISTRATIONS, element: <Registrations/>},
            {path: PATH.CONTACT, element: <Contact/>},
            {path: "*", element: <Navigate to={PATH.HOME} replace />}
        ]
    }
])

export default router;